module.exports = __webpack_public_path__ + "img/VOXEL.689a950c.png";